export default {
   name: 'BadRequest',
   props: {
      errorMessage: {
         typ: String,
         required: true
      }
   },
   data() {
      return {
         modalopen: true
      }
   },
   methods: {
      close() {
         this.modalopen = false
      },
      reload() {
         this.close()
         location.reload()
      },
      goToFeedback() {
         this.close()
         this.$router.push('Feedback')
      }
   }
}
